module.exports = __webpack_public_path__ + "static/img/qualifications_row_1.4673cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_1.png
// module id = fiHj
// module chunks = 1